<template>
  <header class="mobile-header" :class="{ open }" aria-label="Mobile Navigation">
    <div class="container mobile-header-bar">
      <router-link to="/" class="mobile-logo" aria-label="GAP Home" @click="close">
        <img :src="resolvedLogo" alt="GAP Logo" @error="onLogoError" :style="{ width: '140px', height: '70px' }" />
      </router-link>
      <button class="mobile-menu-toggle" aria-expanded="open" aria-controls="mobileMenuPanel" @click="toggle">
        <span class="sr-only">Toggle menu</span>
        <span class="hamburger" :class="{ active: open }"></span>
      </button>
    </div>
    <div id="mobileMenuPanel" class="mobile-menu-panel" v-show="open">
      <nav>
        <ul class="mobile-menu-list">
          <li><router-link to="/" @click="close">GAP Global <span>All Instructor led Classes</span></router-link></li>
          <li><router-link to="/climate" @click="close">Climate <span>Climate Faculty</span></router-link></li>
          <li><a href="https://gaplib.gapmanagementinstitute.org/#/library" target="_blank" rel="noopener" @click="close">GAP Lib <span>GAP Library</span></a></li>
          <li><a href="https://elearning.gapmanagementinstitute.org/" target="_blank" rel="noopener" @click="close">E-learning <span>GAP Online Courses</span></a></li>
          <li><a href="https://gapmanagement.institute/contact-us" target="_blank" rel="noopener" @click="close">Contact Us <span>Get In Touch</span></a></li>
          <li><router-link to="/my-centre" @click="close">My Centre <span>Access Your Site</span></router-link></li>
          <li><router-link to="/downloads" @click="close">Downloads <span>More Information</span></router-link></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileMenu',
  props: {
    logoSrc: {
      type: String,
      default: '/assets/img/gap_logo.png'
    }
  },
  data() {
    return {
      open: false,
      resolvedLogo: this.logoSrc
    }
  },
  methods: {
    toggle() { this.open = !this.open },
    close() { this.open = false },
    onLogoError() {
      if (this.resolvedLogo !== '/assets/img/logo-placeholder.svg') {
        this.resolvedLogo = '/assets/img/logo-placeholder.svg'
      }
    }
  }
}
</script>

<style scoped>
.sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); border: 0; }
.mobile-header { display: none; }
.mobile-header-bar { display: flex; align-items: center; justify-content: space-between; padding: 10px 0; }
.mobile-logo img { display: block; }
.mobile-menu-toggle { background: transparent; border: none; padding: 8px; }
.hamburger, .hamburger::before, .hamburger::after { display: block; width: 26px; height: 3px; background: #222; position: relative; transition: all .2s ease; }
.hamburger::before, .hamburger::after { content: ""; position: absolute; left: 0; }
.hamburger::before { top: -8px; }
.hamburger::after { top: 8px; }
.hamburger.active { background: transparent; }
.hamburger.active::before { transform: translateY(8px) rotate(45deg); }
.hamburger.active::after { transform: translateY(-8px) rotate(-45deg); }
.mobile-menu-panel { border-top: 4px solid #971836; background: #fff; }
.mobile-menu-list { list-style: none; margin: 0; padding: 10px 0; }
.mobile-menu-list > li { border-bottom: 1px solid #eee; }
.mobile-menu-list > li:last-child { border-bottom: none; }
.mobile-menu-list a { display: block; padding: 12px 4px; text-decoration: none; }
.mobile-menu-list a:hover { background: #971836; color: #fff; }
.mobile-menu-list a > span { display: block; font-size: .85rem; color: #777; }
.mobile-menu-list a:hover > span { color: #fff; }
@media (max-width: 991.98px){
  .mobile-header { display: block; position: sticky; top: 0; z-index: 1000; background: #fff; }
}
@media (min-width: 992px){
  .mobile-header { display: none; }
}
</style>
